import React, { createContext } from "react";
import stickers from "../Components/Assets/all_stickers";
import prints from "../Components/Assets/all_prints";

export const Context = createContext(null);

const getDefaultCart = () => {
  return {};
};

const ContextProvider = (props) => {
  const [cartItems, setCartItems] = React.useState(getDefaultCart());

  const addToCart = (itemId, size) => {
    const key = `${itemId}_${size}`;
    setCartItems((prev) => ({ ...prev, [key]: (prev[key] || 0) + 1 }));
  };

  const removeFromCart = (itemId, size) => {
    const key = `${itemId}_${size}`;
    setCartItems((prev) => {
      const currentQty = prev[key] || 0;
      if (currentQty <= 0) return prev;
      return { ...prev, [key]: currentQty - 1 };
    });
  };

  const clearCart = () => {
    setCartItems(getDefaultCart());
  };

  const all_products = [...stickers, ...prints];

  const contextValue = { all_products, cartItems, addToCart, removeFromCart, clearCart };

  return (
    <Context.Provider value={contextValue}>{props.children}</Context.Provider>
  );
};

export default ContextProvider;
